var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vector",
    _vm._b(
      {
        style: { fill: _vm.defaultColor },
        attrs: { id: "farm__" + _vm._uid, "show-viewbox": false },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("clock", {
                  attrs: { fps: 60 },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(clock) {
                          return [
                            _vm.layers
                              ? _c(
                                  "g",
                                  [
                                    _c("rect", {
                                      attrs: {
                                        fill: "#E3DAA6",
                                        y: "-900",
                                        width: "1384",
                                        height: "905"
                                      }
                                    }),
                                    _c(
                                      "foreignObject",
                                      {
                                        attrs: {
                                          x: "0",
                                          y: "0",
                                          width: "100%",
                                          height: "900"
                                        }
                                      },
                                      [
                                        _c("html", [
                                          _c(
                                            "body",
                                            {
                                              style: [
                                                {
                                                  "background-color":
                                                    _vm.defaultColor
                                                },
                                                { height: "900px" }
                                              ]
                                            },
                                            [_vm._t("default")],
                                            2
                                          )
                                        ])
                                      ]
                                    ),
                                    _c("layer", {
                                      attrs: {
                                        id: "bbbb",
                                        position: _vm.layers["background"],
                                        layer: _vm.layers["background"]
                                      }
                                    }),
                                    _c("layer", {
                                      attrs: {
                                        position: _vm.layers["barn"],
                                        layer: _vm.layers["barn"]
                                      }
                                    }),
                                    _c("cow", {
                                      attrs: {
                                        keyframe: clock.keyframe,
                                        repeat: true,
                                        align: "topleft",
                                        fit: true,
                                        x: 100,
                                        y: 650,
                                        width: "300",
                                        height: "300"
                                      }
                                    }),
                                    _c("cow", {
                                      attrs: {
                                        keyframe: clock.keyframe,
                                        repeat: true,
                                        align: "topleft",
                                        fit: true,
                                        x: 600,
                                        y: 650,
                                        width: "300",
                                        height: "300"
                                      }
                                    }),
                                    _c("farmer", {
                                      attrs: {
                                        keyframe: clock.keyframe,
                                        repeat: true,
                                        x: -200 + (clock.keyframe % 6000) / 4,
                                        y: 800
                                      }
                                    }),
                                    _c("cow", {
                                      attrs: {
                                        keyframe: clock.keyframe,
                                        repeat: true,
                                        align: "topleft",
                                        fit: true,
                                        x: 350,
                                        y: 650,
                                        width: "300",
                                        height: "300"
                                      }
                                    }),
                                    _c("cow", {
                                      attrs: {
                                        keyframe: clock.keyframe,
                                        repeat: true,
                                        align: "topleft",
                                        fit: true,
                                        x: 850,
                                        y: 650,
                                        width: "300",
                                        height: "300"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              ]
            },
            proxy: true
          }
        ])
      },
      "vector",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }